export default __webpack_public_path__ + "assets/images/decor.2fe4bd.avif";